<template>
  <Loader :flag="flag.isLoading.get"  :class="[s.wrap, !['production', 'develop'].includes(helper.env.name) ? s.isDevelop : '']">
    <div v-if="!flag.isLoading.get">
      <ul :class="s.list">
        <li
          v-for="ts in taxiStands"
          :key="ts.id"
          class="bdr-b"
          :class="selectedId === ts.id ? s.selected : ''"
          @click="selectedId = ts.id">
          <div
            class="d-flex justify-content-between align-items-center p-3">
            <div class="d-flex align-items-center">
              <i class="fa-solid fa-map-pin"/>
              <div class="ms-3">{{ ts.label }}</div>
            </div>
            <div :class="s.circle"/>
          </div>
        </li>
      </ul>
      <div :class="[s.submit, helper.env.name !== 'production' ? s.isDevelop : '']">
        <large-btn
          :disabled="!readySubmit"
          @click="submit"><i class="fa-regular fa-download me-2"/>変更する
        </large-btn>
      </div>
    </div>
  </Loader>
</template>

<script>
import { mapState } from 'vuex';
import Loader from '@/components/parts/Loader';
import LargeBtn from '@/components/parts/LargeBtn';
import cf from '@/mixins/commonFunctions';

export default {
  name: 'change-vehicle-form',
  components: {
    LargeBtn,
    Loader,
  },
  mixins: [cf],
  data() {
    return {
      flag: {
        isLoading: {
          get: true,
        },
        readyRegistVehicle: false,
      },
      taxiStands: [],
      selectedId: 0,
    };
  },
  created() {},
  computed: {
    ...mapState(['user', 'helper']),
    readySubmit() {
      return this.selectedId !== null && this.selectedId !== (this.user.taxiStand[0]?.id || 0);
    },
    officeId() {
      return this.user.offices?.[0]?.id || 0;
    },
  },
  watch: {
    user: {
      handler() {
        this.selectedId = this.user.taxiStand[0]?.id || 0;
        this.getTaxiStands();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    getTaxiStands() {
      if (!this.officeId) return;
      this.flag.isLoading.get = true;
      this.taxiStands = [];

      const params = {
        type: 12,
        officeId: this.officeId,
        order: 'asc',
        orderBy: 'order',
      };

      this.axios({
        method: 'GET',
        url: '/v1/taxiStand/get/list',
        params,
      })
        .then((response) => {
          const res = response.data;
          this.taxiStands = res.taxiStands.data;
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        })
        .finally(() => {
          this.flag.isLoading.get = false;
        });
    },

    submit() {
      this.showLoading();
      const data = {
        driver_id: this.user.id,
        taxi_stand_id: this.selectedId,
      };

      this.axios({
        method: 'POST',
        url: '/v1/taxiStandDriver/create',
        data,
      })
        .then(() => {
          alert('待機所を設定しました。');
          this.$store.dispatch('user/update');
        })
        .catch((error) => {
          alert('待機所の設定中にエラーが発生しました。\n再度お試しください。');
          if (error.response) console.log(error.response.data);
          else console.log(error);
        })
        .finally(() => {
          this.hideLoading();
          this.$emit('changedVehicle');
        });
    },

    changeFormSubmitFlag(bool) {
      this.flag.readyRegistVehicle = bool;
    },

    initRegistVehicleForm() {
      this.vehicleBaseData.forEach((item) => {
        item.value = '';
      });
    },

    registVehicle(flag) {
      this.showLoading();
      const data = {
        flag,
        ...cf.pullOutValues(this.vehicleBaseData),
        user_id: this.user.id,
      };

      this.axios({
        method: 'POST',
        url: '/v1/vehicle/create/',
        data,
      })
        .then((response) => {
          const res = response.data;
          if (res.vehicleId) {
            this.initRegistVehicleForm();
            if (confirm('車両登録が完了しました。\n乗車車両を今回登録した車両に変更しますか？')) {
              this.selectedVehicleId = res.vehicleId;
              this.submit();
            } else {
              this.hideLoading();
            }
          }
          this.getVehicles();
        })
        .catch((error) => {
          alert('車両登録中にエラーが発生しました。\n再度お試しいただくか、管理者へお問い合わせください。');
          if (error.response) console.log(error.response.data);
          console.log(error);
          this.hideLoading();
        });
    },
  },
};
</script>

<style lang="scss" module="s">
.wrap {
  padding-bottom: 100px;
  &.isDevelop {
    padding-bottom: 150px;
  }
}
.circle {
  width: 30px;
  height: 30px;
  border-radius: 30px;
  border: 1px solid var(--border-gray);
  position: relative;
}
.selected {
  background-color: rgba(#0D6EFD, .1);
  i {
    color: var(--primary-blue);
  }
  .circle {
    &::after {
      content: '';
      position: absolute;
      top: 20%; left: 20%;
      width: 60%;
      height: 60%;
      background-color: var(--primary-blue);
      border-radius: 60%;
    }
  }
}
.submit {
  position: fixed;
  bottom: var(--footer-height);
  left: 0px;
  width: 100%;
  background-color: rgba(#ffffff, .2);
  padding: 8px;

  &.isDevelop {
    bottom: calc(var(--footer-height) + 50px);
  }
}
</style>
